var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drag-drop-container',{attrs:{"group":"tasks"}},[_c('div',{class:_vm.scrolledClass},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"body",style:(_vm.bodyStyle)},[_c('nuxt')],1),_vm._v(" "),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }